<template>
  <div>
    <top-bar heading="Signoff Forms"></top-bar>
    <div class="container-fluid mt-3">
      <b-card>
        <vue-good-table
                mode="remote"
                :columns="columns"
                :rows="forms.data"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                :pagination-options="paginationOptions"
                :isLoading="loading"
                :total-rows="totalRecords">
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field === 'status'" class="mx-auto text-center">
              <div class="btn-group">
                <span class="btn btn-info p-2" v-if="!props.row.supervisor_at">Supervisor</span>
                <span class="btn btn-warning p-2" v-if="!props.row.student_at">Student</span>
                <span class="btn btn-primary p-2" v-if="!props.row.assessor_at">Assessor</span>
                <span class="btn btn-success p2" v-if="props.row.completed_at">Completed</span>
              </div>
            </div>
            <span v-else-if="props.column.field === 'actions'">
              <span class="btn-group" role="group">
                <button type="button" class="btn btn-danger" @click="deleteForm(props.row.id)" v-b-popover.hover="'Delete Form'">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </button>
                <button type="button" class="btn btn-warning" v-b-popover.hover="'Export Form to PDF'" @click="exportForm(props.row.id)">
                  <font-awesome-icon icon="file-pdf"></font-awesome-icon>
                </button>
                <router-link :to="'/signoff_forms/' + props.row.id" class="btn btn-primary">
                 <font-awesome-icon icon="eye"></font-awesome-icon>
                </router-link>

              </span>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </b-card>
    </div>
  </div>
</template>

<script>
import forEach from 'lodash-es/forEach'

export default {
  name: 'SignoffForms',
  data () {
    return {
      forms: {
        meta: {
          current_page: 1,
          per_page: 10
        },
        data: []
      },
      loading: true,
      columns: [
        {
          label: 'Form',
          field: 'form_name',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Status',
          field: 'status',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Student',
          field: 'student.name_full',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Assessor',
          field: 'assessor.name_full',
          filterOptions: {
            enabled: true
          }
        },
        {
          label: 'Created',
          field: 'created_at'
        },
        {
          label: 'Actions',
          field: 'actions'
        }
      ],
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      }
    }
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps)
    },

    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadForms()
    },

    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadForms()
    },

    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field
        }
      })
      this.loadForms()
    },

    onColumnFilter (params) {
      this.updateParams(params)
      this.loadForms()
    },

    loadForms () {
      let params = {
        page: this.serverParams.page,
        limit: this.serverParams.perPage,
        sort: this.serverParams.sort.field,
        sortBy: this.serverParams.sort.type
        // search: this.search
      }
      this.loading = true

      forEach(this.serverParams.columnFilters, (value, index) => {
        params['filter[' + index + ']'] = value
      })

      this.axios.get('/signoff', { params }).then(rsp => {
        this.forms = rsp.data
        this.loading = false
      })
    },
    getStatus (status) {
      switch (status) {
        case 1:
          return '<span class="badge badge-primary p-2">Assessor</span>'
        case 2:
          return '<span class="badge badge-info p-2">Supervisor</span>'
        case 3:
          return '<span class="badge badge-warning p-2">Student</span>'
        case 4:
          return '<span class="badge badge-danger p-2">Approval</span>'
        case 5:
          return '<span class="badge badge-success p-2">Complete</span>'
        default:
          return '<span class="badge badge-danger p-2">Unknown</span>'
      }
    },
    deleteForm (id) {
      this.loading = true
      this.axios.delete('/signoff/' + id).then(() => {
        this.$snotify.success('Form Deleted')
        this.loadForms()
      })
    },
    resendForm (id) {
      this.axios.get('/signoff/resend/' + id).then(() => {
        this.$snotify.success('Form Resent')
      })
    },
    exportForm (id) {
      this.axios.get('/signoff/export/' + id).then(() => {
        this.$snotify.success('Form is now being exported as a PDF')
      })
    }
  },
  computed: {
    paginationOptions () {
      return {
        enabled: true,
        mode: 'records',
        perPage: this.forms.meta.per_page,
        position: 'bottom',
        dropdownAllowAll: false,
        setCurrentPage: this.forms.meta.current_page || 1,
        nextLabel: 'next',
        prevLabel: 'prev',
        rowsPerPageLabel: 'Rows per page',
        ofLabel: 'of',
        allLabel: 'All'
      }
    },
    totalRecords () {
      return this.forms.meta.total || 0
    }
  },
  mounted () {
    this.loadForms()
  },
  metaInfo: {
    title: 'Signoff Forms'
  }
}
</script>
